import Vue from "vue";
import Vuex from "vuex";
import adminModule from "./modules/admin-module";
import analyseModule from "./modules/analyse-module";
import apiModule from "./modules/api-module";
import authModule from "./modules/auth-module";
import collectionModule from "./modules/collection-module";
import documentModule from "./modules/document-module";
import favoriteModule from "./modules/favorite-module";
import fieldModule from "./modules/field-module";
import filterModule from "./modules/filter-module";
import modelModule from "./modules/model-module";
import poolModule from "./modules/pool-module";
import projectModule from "./modules/project-module";
import settingModule from "./modules/setting-module";
import ttcModule from "./modules/ttc-module";
import userModule from "./modules/user-module";
import visualizationModule from "./modules/visualization-module";
import impexpModule from "./modules/impexp-module";
import layoutModule from "./modules/layout-module";
import realmModule from "./modules/realm-module";
import chatbotModule from "./modules/chatbot-module";
import classificationModule from "./modules/classification-module";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    admin: adminModule,
    analyse: analyseModule,
    api: apiModule,
    auth: authModule,
    collection: collectionModule,
    document: documentModule,
    favorite: favoriteModule,
    field: fieldModule,
    filter: filterModule,
    model: modelModule,
    pool: poolModule,
    project: projectModule,
    setting: settingModule,
    ttc: ttcModule,
    user: userModule,
    visualization: visualizationModule,
    impexp: impexpModule,
    layout: layoutModule,
    realm: realmModule,
    chatbot: chatbotModule,
    classification: classificationModule
  }
});
